import { useI18n } from "./i18n";

export const CHANNELS = ["airbnb", "booking", "diretto", "altro"];
export const PAY_METHODS = ["SumUp", "Stripe", "bonifico", "contanti", "OTA"];
export const APT_STATUS = ["attivo", "in_acquisizione", "sospeso", "terminato", "archivio"];
export const PAY_STATUS = ["pagato", "parziale", "in_sospeso"];
export const DOC_STATUS = ["ricevuto", "mancante"];
export const CHK_STATUS = ["inviate", "da_inviare"];
export const CLEAN_STATUS = ["da_fare", "in_corso", "completata"];
export const MAINT_STATUS = ["aperto", "in_lavorazione", "risolto"];
export const PRIORITY = ["bassa", "media", "alta", "urgente"];

const STATUS_STYLE = {
  attivo: "bg-emerald-100 text-emerald-700",
  in_acquisizione: "bg-blue-100 text-blue-700",
  sospeso: "bg-amber-100 text-amber-800",
  terminato: "bg-orange-100 text-orange-700",
  archivio: "bg-slate-200 text-slate-600",
  in_uscita: "bg-rose-100 text-rose-700",
  pagato: "bg-emerald-100 text-emerald-700",
  parziale: "bg-amber-100 text-amber-800",
  in_sospeso: "bg-rose-100 text-rose-700",
  ricevuto: "bg-emerald-100 text-emerald-700",
  mancante: "bg-rose-100 text-rose-700",
  inviate: "bg-emerald-100 text-emerald-700",
  da_inviare: "bg-slate-100 text-slate-600",
  da_fare: "bg-slate-100 text-slate-600",
  in_corso: "bg-blue-100 text-blue-700",
  completata: "bg-emerald-100 text-emerald-700",
  aperto: "bg-rose-100 text-rose-700",
  in_lavorazione: "bg-blue-100 text-blue-700",
  risolto: "bg-emerald-100 text-emerald-700",
  bassa: "bg-slate-100 text-slate-600",
  media: "bg-blue-100 text-blue-700",
  alta: "bg-amber-100 text-amber-800",
  urgente: "bg-rose-100 text-rose-700",
};

const LABEL_KEY = {
  attivo: "active", in_acquisizione: "acquiring", sospeso: "suspended", terminato: "terminated", archivio: "archived", in_uscita: "exiting",
  pagato: "paid", parziale: "partial", in_sospeso: "pending",
  ricevuto: "received", mancante: "missing", inviate: "sent", da_inviare: "toSend",
  da_fare: "todo", in_corso: "inProgress", completata: "completed",
  aperto: "open", in_lavorazione: "working", risolto: "resolved",
  bassa: "low", media: "medium", alta: "high", urgente: "urgent",
};

export function StatusBadge({ value }) {
  const { t } = useI18n();
  const style = STATUS_STYLE[value] || "bg-slate-100 text-slate-600";
  const label = LABEL_KEY[value] ? t(LABEL_KEY[value]) : value;
  return (
    <span data-testid={`badge-${value}`} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${style}`}>
      {label}
    </span>
  );
}

export const eur = (n) => "€ " + (Number(n) || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
export const fmtDate = (s) => { try { return new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }); } catch { return s; } };
